export default "__VITE_ASSET__5dffc7e3__"